import styles from 'partials/filter-box.module.scss';

export const FilterBox = ({ title, children }) => {
	return (
		<div className={styles.box}>
			{title && <h3 className={styles.title}>{title}</h3>}
			<div className={styles.body}>{children}</div>
		</div>
	);
};
